import type { Branch } from '../../types/storefront'

/** Coordinates are optional in the contract, so fall back to the written
 *  address — a query search still lands the customer on the right place. */
export function directionsUrl(branch: Branch): string | null {
  if (branch.latitude !== null && branch.longitude !== null) {
    return `https://www.google.com/maps/search/?api=1&query=${branch.latitude},${branch.longitude}`
  }
  const written = [branch.name, branch.address, branch.city].filter(Boolean).join(', ')
  return written ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(written)}` : null
}
